export const routeProps = {
  path: '/start',
  exact: true,
};

export default () => routeProps;
